import gql from "graphql-tag";

import {FetchPolicy} from "@khanacademy/wonder-blocks-data";
import {useQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {
    getAiGuideThreads as Data,
    getAiGuideThreads_aiGuideThreads_threads as Threads,
    getAiGuideThreadsVariables as Variables,
} from "./__graphql-types__/getAiGuideThreads.ts";

export const USE_GET_AI_GUIDE_THREADS_DATA_QUERY: GqlOperation<
    Data,
    Variables
> = gqlOp(gql`
    query getAiGuideThreads(
        $kaid: String!
        $hasCoeditor: Boolean!
        $limit: Int!
    ) {
        aiGuideThreads(kaid: $kaid, hasCoeditor: $hasCoeditor, limit: $limit) {
            threads {
                id
                coeditingDocument(excludeArchived: true) {
                    id
                    title
                    configName
                    threadId
                    persona
                    latestSnapshot {
                        id
                        createdAt
                    }
                }
                blooketQuestionSet {
                    id
                    title
                    threadId
                    persona
                    lastUpdatedAt
                }
            }
        }
    }
`);

type UseGetAiGuideThreadsDataQuery = {
    threads: null | Array<Threads | null | undefined>;
    status: string;
};

export const useGetAiGuideThreadsDataQuery = (
    kaid: string,
    hasCoeditor: boolean,
    limit: number,
): UseGetAiGuideThreadsDataQuery => {
    const [result] = useQuery(USE_GET_AI_GUIDE_THREADS_DATA_QUERY, {
        variables: {
            kaid,
            hasCoeditor,
            limit,
        },
        fetchPolicy: FetchPolicy.NetworkOnly,
    });

    if (result.status !== "success") {
        return {
            threads: null,
            status: result.status,
        };
    }

    const threadsData: null | Array<Threads | null | undefined> =
        result.data?.aiGuideThreads?.threads ?? null;

    try {
        if (!result.data) {
            throw new KAError(
                "No user data from GraphQL query for current user",
                Errors.Internal,
            );
        }
        return {
            threads: threadsData,
            status: result.status,
        };
    } catch (error: any) {
        return {
            threads: threadsData,
            status: result.status,
        };
    }
};
